module.exports = __webpack_public_path__ + "static/dl2-stay-human_screen2-276721f2a1851113ad963694b6511a5a.png";